var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4Active(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15625 12.6851V1.5C7.15625 1.22386 7.38011 1 7.65625 1H21.5002C21.7764 1 22.0002 1.22386 22.0002 1.5V22.5C22.0002 22.7761 21.7764 23 21.5002 23H7.15625",
    stroke: "#28A1D9",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46582 4.65381H19.69",
    stroke: "#28A1D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46582 7.7749H19.69",
    stroke: "#28A1D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46582 10.896H19.69",
    stroke: "#28A1D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5957 14.0171H19.6899",
    stroke: "#28A1D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1865 17.1382H19.6903",
    stroke: "#28A1D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14995 22.9999C9.99419 22.9999 12.2999 20.6823 12.2999 17.8234C12.2999 14.9646 9.99419 12.647 7.14995 12.647C4.30571 12.647 2 14.9646 2 17.8234C2 20.6823 4.30571 22.9999 7.14995 22.9999Z",
    stroke: "#28A1D9",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87917 20.9669V20.1988C6.44067 20.1912 5.98626 20.0541 5.72119 19.8638L5.90295 19.3546C6.1756 19.5373 6.56866 19.6819 6.99278 19.6819C7.52973 19.6819 7.89326 19.3698 7.89326 18.9366C7.89326 18.5187 7.59789 18.2599 7.03822 18.0315C6.26648 17.727 5.79011 17.3776 5.79011 16.7161C5.79011 16.085 6.23619 15.6054 6.93294 15.4912V14.7231H7.40174V15.4608C7.85539 15.476 8.1659 15.5978 8.38553 15.7272L8.1962 16.2289C8.03716 16.1375 7.7274 15.9701 7.2427 15.9701C6.6603 15.9701 6.44067 16.3202 6.44067 16.624C6.44067 17.0198 6.72089 17.217 7.37902 17.491C8.15757 17.8108 8.55139 18.2066 8.55139 18.8834C8.55139 19.484 8.13561 20.0473 7.35554 20.1759V20.9669H6.87917Z",
    fill: "#28A1D9",
    stroke: "#28A1D9",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4Active);
export default __webpack_public_path__ + "static/media/Icon4_active.076d3376cfe5417065debe832a990b77.svg";
export { ForwardRef as ReactComponent };